import { css } from 'linaria';
import tokens from './tokens';
import { TimingDurationValues, TransitionPropertyValues, TimingFunctionValues } from './types';

const transitionPropertyAll = css`
    transition-property: all;
`;

const transitionPropertyNone = css`
    transition-property: none;
`;

const transitionPropertyInherit = css`
    transition-property: inherit;
`;

const transitionPropertyVariants: Record<TransitionPropertyValues, string> = {
    all: transitionPropertyAll,
    none: transitionPropertyNone,
    inherit: transitionPropertyInherit,
};

const transitionDurationFast = css`
    transition-duration: ${tokens.timingDurations.fast};
`;

const transitionDurationNormal = css`
    transition-duration: ${tokens.timingDurations.normal};
`;

const transitionDurationSlow = css`
    transition-duration: ${tokens.timingDurations.slow};
`;

const transitionDurationSlowest = css`
    transition-duration: ${tokens.timingDurations.slowest};
`;

const transitionDurationVariants: Record<TimingDurationValues, string> = {
    fast: transitionDurationFast,
    normal: transitionDurationNormal,
    slow: transitionDurationSlow,
    slowest: transitionDurationSlowest,
};

const transitionTimingFunctionStandard = css`
    transition-timing-function: ${tokens.timingFunctions.standard};
`;

const transitionTimingFunctionSlow = css`
    transition-timing-function: ${tokens.timingFunctions.slow};
`;

const transitionTimingFunctionFast = css`
    transition-timing-function: ${tokens.timingFunctions.fast};
`;

const transitionTimingFunctionSharp = css`
    transition-timing-function: ${tokens.timingFunctions.sharp};
`;

const transitionTimingFunctionSpring = css`
    transition-timing-function: ${tokens.timingFunctions.spring};
`;

const transitionTimingFunctionVariants: Record<TimingFunctionValues, string> = {
    standard: transitionTimingFunctionStandard,
    slow: transitionTimingFunctionSlow,
    fast: transitionTimingFunctionFast,
    sharp: transitionTimingFunctionSharp,
    spring: transitionTimingFunctionSpring,
};

export default {
    transitionPropertyVariants,
    transitionDurationVariants,
    transitionTimingFunctionVariants,
};
